import {useContext} from "react";
import { SecurityObjectContext } from "src/App";
import { PermissionType } from "src/types/security";

const useSecurityObject = () => {
    const { dictionarySecurityObject } = useContext(SecurityObjectContext);
    
    const isReadPermissionCode = (permissionCode: number) : boolean =>
        (permissionCode === PermissionType.Read) || (permissionCode === PermissionType.Write);

    const isWritePermissionCode = (permissionCode: number) : boolean =>
        (permissionCode === PermissionType.Write);
    
    const getPermissionTypeCode = (componentName: string, objectName: string) : number =>
        dictionarySecurityObject ?
            dictionarySecurityObject[componentName]?.find(x => x.descripcion === objectName)?.codPermisoTipo ?? PermissionType.Write
            : PermissionType.None;

    const hasReadPermission = (componentName: string, objectName: string) : boolean => {
        const permissionTypeCode : number = getPermissionTypeCode(componentName, objectName);
        
        return isReadPermissionCode(permissionTypeCode);
    }

    const hasWritePermission = (componentName: string, objectName: string) : boolean => {
        const permissionTypeCode : number = getPermissionTypeCode(componentName, objectName);
        
        return isWritePermissionCode(permissionTypeCode);
    }

    const hasReadWorkflowPermission = (permissionWorkflowCode: number, componentName: string, objectName: string) : boolean =>
        isReadPermissionCode(permissionWorkflowCode) && hasReadPermission(componentName, objectName);

    const hasWriteWorkflowPermission = (permissionWorkflowCode: number, componentName: string, objectName: string) : boolean => 
        isWritePermissionCode(permissionWorkflowCode) && hasWritePermission(componentName, objectName);

    return { dictionarySecurityObject, hasReadPermission, hasWritePermission, hasReadWorkflowPermission, hasWriteWorkflowPermission };
};

export default useSecurityObject;